import React from 'react';
import SnookerSection from '../components/SnookerSection';
import ReviewCarousel from '../components/ReviewCarousel';

const PoolPage: React.FC = () => {
  const poolImages = [
    {
      src: '/images/snooker/The Creamery 8 American Pool Tables.jpg',
      alt: 'The Creamery 8 American Pool Tables'
    },
        {
      src: '/images/snooker/pool6.jpg',
      alt: 'The Creamery Pool'
    },
            {
      src: '/images/snooker/pool4.jpg',
      alt: 'The Creamery Pool'
    },
    {
      src: '/images/snooker/The Creamery 9 Ball Pool.jpg',
      alt: 'The Creamery 9 Ball Pool'
    },
    {
      src: '/images/snooker/The Creamery Busy Pool Room.jpg',
      alt: 'The Creamery Busy Pool Room'
    },
    {
      src: '/images/snooker/The Creamery Pool.jpg',
      alt: 'The Creamery Pool'
    },


  ];

  return (
    <div className="pt-20 bg-primary-black">
      <SnookerSection 
        showGallery={true}
        showCoachingBanner={true}
        eyebrow="POOL"
        title="Pool Hall"
        subtitle="We have 8 pool tables available for hire — perfect for a casual game with friends or competitive matches."
        tableType="pool"
        poolTables="8"
        galleryImages={poolImages}
      />

      <ReviewCarousel type="snooker" />
      
      {/* Reservation CTA Section */}
      <section className="relative py-20 bg-primary-black overflow-hidden">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary-gold opacity-5 rounded-full blur-3xl"></div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-primary-gold mb-6 font-display">
            Book Your Table
          </h2>
          <p className="text-gray-300 text-lg mb-8">
            Reserve a snooker or pool table for your next game
          </p>
          <a 
            href="/book" 
            className="inline-block bg-primary-gold text-primary-black px-12 py-4 rounded-full font-semibold text-lg hover:bg-primary-black hover:text-primary-gold hover:border-2 hover:border-primary-gold transition-all"
            aria-label="Reserve a pool table"
          >
            Make a Reservation
          </a>
        </div>
      </section>
    </div>
  );
};

export default PoolPage;
